import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';
import { Icon } from './Icon';
import { PopupOverlay } from './PopupOverlay';
import { atom } from 'recoil';
import { useSetRecoilState } from 'recoil';
import { useRecoilValue } from 'recoil';
import { Suggestion, SuggestionDropDown } from './forms/SuggestionDropDown';

export interface SearchPopupConfig {
  open: boolean;
  closeFn: () => void;
  value?: Suggestion;
  onSelect?: (suggestion: Suggestion) => void;
  suggestions?: Suggestion[];
}

export interface SearchPopupProps {
  config: SearchPopupConfig | null;
}

export const SearchPopupState = atom<SearchPopupProps>({
  key: 'SearchPopupState',
  default: {
    config: null,
  },
});

export const useShowSearchPopup: () => (config: SearchPopupConfig | null) => void = () => {
  const setState = useSetRecoilState(SearchPopupState);
  return (config: SearchPopupConfig | null) => {
    setState({ config });
  }
}
export const useSearchPopup: () => SearchPopupConfig | null = () => useRecoilValue(SearchPopupState).config;


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.background};
  padding: 6rem 10rem;
  position: relative;
`;

const CloseIconWrapper = styled.div`
  position: absolute;
  top: 2rem;
  right: 2.5rem;
  color: ${Colors.gray};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${Colors.gray};
`;

const ButtonWrapper = styled.div`
  cursor: pointer;
`;


export const SearchPopup: FC<SearchPopupProps> = (props) => {
  const { config } = props;
  const { suggestions, value, onSelect } = config;

  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      if (!!config?.open && e.keyCode === 27) {   // escape key
        config?.closeFn();
      }
    };
    document.addEventListener('keydown', listener);

    return () => document.removeEventListener('keydown', listener);
  });

  useEffect(() => {
    if (config?.open) {
      const input = document.querySelector('#search-popup-input') as HTMLInputElement;
      if (input && input.focus) {
        input.focus();
      }
    }
  }, [config?.open]);
  
  return (
    <PopupOverlay {...{ open: config?.open }}>
      <Wrapper>
        <CloseIconWrapper>
          <ButtonWrapper
            onClick={() => {
                config?.closeFn();
            }}
          >
            <Icon icon={'close'} size={18} />
          </ButtonWrapper>
        </CloseIconWrapper>

        <ContentWrapper>
          <SuggestionDropDown
            id={'search-popup-input'}
            label={'Geben Sie einen Kundennamen, oder die GP-Nummer ein.'}
            showSearchResultsOnly
            onChange={(suggestion) => {
              // console.log("change", suggestion);
              if (onSelect) {
                onSelect(suggestion);
              }
            }}
            value={value}
            suggestions={suggestions}
            inline={true}
            // value={{ id: '', text: '' }}
          />
        </ContentWrapper>

      </Wrapper>
    </PopupOverlay>
  );
};
